// removed by extract-text-webpack-plugin
module.exports = {"navigation":"n0x7UVBpuKlqiDSyVJkMv"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Navigation/style.scss
// module id = 903
// module chunks = 0